import { useState, useEffect } from 'react';
import { EconomicCalendar } from "react-ts-tradingview-widgets";
import { LockClosedIcon } from '@heroicons/react/24/outline';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';

function Calendar() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslations();

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch('https://api.maxprofitacademy.com/user', {
          method: 'GET',
          headers: { 'token': JSON.parse(token) }
        });
        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasValidCourse) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <LockClosedIcon className="h-16 w-16 text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold mb-2">{t('calendar.noAccess')}</h2>
        <p className="text-gray-600">{t('calendar.activateCourse')}</p>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="">
      <EconomicCalendar locale="ru" colorTheme="light" height={400} width="100%"></EconomicCalendar>
      <BottomNav />
    </div>
  );
}

export default Calendar; 